import React, { Component } from 'react';

class ShowMoreButton extends Component {
  render() {
    return (
      <div style={{textAlign: "center"}}>
	      <button className="button" onClick={() => this.props.showMore()} style={{marginTop: "3em"}}>Vis Flere</button>
      </div>
    );
  }
}

export default ShowMoreButton;



// WEBPACK FOOTER //
// ./src/modules/common/ShowMoreButton.js